export default "__VITE_ASSET__DXm1MCPr__"